import { render, staticRenderFns } from "./HomeNewView.vue?vue&type=template&id=2e0351f0&scoped=true"
import script from "./HomeNewView.vue?vue&type=script&lang=js"
export * from "./HomeNewView.vue?vue&type=script&lang=js"
import style0 from "./HomeNewView.vue?vue&type=style&index=0&id=2e0351f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0351f0",
  null
  
)

export default component.exports